import { Box, Table, Text } from '@nimbus-ds/components';
import { ProductTransferDetailsResponseDto } from '@tiendanube/common';
import { HiddenVariantTag } from 'domains/Catalog/Categories/components';
import { extractTransferProductDetails } from 'domains/Catalog/Transfers/utils';
import { TransferHeaderCells, TransferVariantCell } from './components';
import { TransferDetailStatus, TransferProductCell } from '../../../components';

type ProductVariant =
  ProductTransferDetailsResponseDto['productVariants'][number];

interface TransferTableProps {
  productVariants: ProductVariant[];
}

function TransferTable({ productVariants }: Readonly<TransferTableProps>) {
  const selectedProducts = extractTransferProductDetails(productVariants);

  const renderQuantityDone = (variant: ProductVariant) => (
    <Text>{variant.quantityDone}</Text>
  );

  if (productVariants.length === 0) {
    return null;
  }

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <TransferHeaderCells />
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {selectedProducts.map((product) => (
          <Table.Row key={`${product.productId}`}>
            <Table.Cell>
              <TransferProductCell product={product} />
            </Table.Cell>
            <TransferVariantCell
              productId={product.productId}
              productVariants={productVariants}
              renderProp={(variant: ProductVariant) => (
                <Box display="flex" flexDirection="row" gap="2">
                  <Text>{variant.variantName}</Text>
                  <HiddenVariantTag visible={variant.variantVisible} />
                </Box>
              )}
            />
            <TransferVariantCell
              productId={product.productId}
              productVariants={productVariants}
              renderProp={({ quantity }) => <Text>{quantity}</Text>}
            />
            <TransferVariantCell
              productId={product.productId}
              productVariants={productVariants}
              renderProp={renderQuantityDone}
            />
            <TransferVariantCell
              productId={product.productId}
              productVariants={productVariants}
              renderProp={(variant: ProductVariant) => (
                <TransferDetailStatus
                  status={variant.status}
                  isPartial={variant.quantityDone < variant.quantity}
                />
              )}
            />
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}

export default TransferTable;
